export const ROUTER_NAME = {
  ALL: '*',
  DEFAULT: '/',
  NOT_FOUND: '/404',
  LOGIN: '/login',
  // REGISTER: '/register',
  // SIGN_UP_WITH_BOOKIPAY: '/sign-up-with-bookipay',
  // FORGOT_PASSWORD: '/forgot-password',
  // RESET_PASSWORD: '/reset-password',
  PAY: '/pay',
  GET_PAID: '/get-paid',
  PEOPLE: '/people',
  INTEGRATION: '/integration',
  SETTINGS: '/settings',
  ACCEPT_INVITE: '/acceptInvite',
  ONBOARD: '/onboard',
  ONBOARD_WITH_PROVIDER_COMPANY: '/onboard/:provider/:companyId',
  ONBOARD_US: '/onboard-us',
  ONBOARD_AUS: '/onboard-aus',
  TRANSACTIONS: '/transaction',
  PAYOUTS: '/payouts',
  DISPUTES: '/disputes',
  TRANSACTION_DETAIL: '/transaction/:provider/:id',
  DOWNLOAD: '/download',
  DOWNLOAD_QR: '/downloadqr',
  VENDOR_BANK: '/vendorBank',
  SUBSCRIPTION: '/subscription',
  SUBSCRIPTION_UPDATE: '/subscription/update',
  SUBSCRIPTION_PAYMENT_METHOD: '/subscription/payment-method',
  SUBSCRIPTION_INVOICE_HISTORY: '/subscription/invoice-history',
  SUBSCRIPTION_EDIT: '/subscription/edit',
  SUBSCRIPTION_ORDER: '/subscription/order',
  SUBSCRIPTION_CANCEL: '/subscription/cancel',
  SUBSCRIPTION_CONFIRM_CANCEL: '/subscription/confirm-cancel',
  SUBSCRIPTION_CANCEL_SURVEY: '/subscription/cancel-survey',
  SUBSCRIPTION_CANCEL_SUCCESS: '/subscription/cancel-success',
  SUBSCRIPTION_DOWNGRADE_SURVEY: '/subscription/downgrade-survey',
  SUBSCRIPTION_REACTIVATE: '/subscription/reactivate',
  SUBSCRIPTION_SESSION_EXPIRED: '/subscription/session-expired',
  SUBSCRIPTION_MOBILE_PAYWALL: '/subscription/mobile/paywall',
  SUBSCRIPTION_V2: '/subscription/v2',
  PAYMENT_LINK: '/payment-links',
  PAYMENT_LINK_LIST: '/payment-links/manage',
  PAYMENT_LINK_NEW: '/payment-links/new',
  PAYMENT_LINK_SHARE: '/payment-links/:id/share',
  PAYMENT_LINK_EDIT: '/payment-links/:id/edit',
  PAYMENT_LINK_VIEW: '/pay/:id'
};
